/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentGuidanceRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/guidance';

export default class AutomationFinAIAgentEcommerceGuidanceRoute extends AutomationFinAIAgentGuidanceRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.guidance',
  };

  beforeModel() {
    if (!this.appService.app.canUseFinEcommerceAgent) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
      return;
    }
  }
}
